import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Admin: alle kredittvilkår, som oppslag på nøkkelen user_<uid> / org_<orgId>.
export function useInvoiceCustomers() {
  const [customers, setCustomers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => onSnapshot(
    collection(db, 'invoiceCustomers'),
    snap => {
      const map = {};
      snap.docs.forEach(d => { map[d.id] = { id: d.id, ...d.data() }; });
      setCustomers(map);
      setLoading(false);
    },
    err => {
      console.error('useInvoiceCustomers:', err);
      setError(err);
      setLoading(false);
    },
  ), []);

  return { customers, loading, error };
}
